import type { EmailEventTemplateData } from "../../../shared/types";
import BaseWriteApi from "../BaseWriteApi";

export default class EmailDataApi extends BaseWriteApi<EmailEventTemplateData> {
  /* PRIVATE APIS */

  /* NEEDED BASE API OVERRIDES */

  get db() {
    return `${this.dbPrefix}email_data`;
  }
}
